module.exports = __webpack_public_path__ + "img/leftthigh-mesomorph-female.57947785.svg";